import React from 'react';
import CloseIcon from '@heroicons/react/24/outline/XMarkIcon';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import Cart from 'components/commercetools-ui/organisms/cart-slideout';
import { Link } from 'components/commercetools-ui/organisms/header/types';
import { PaymentMethod } from 'components/commercetools-ui/organisms/order-payment-section/types';
import { useFormat } from 'helpers/hooks/useFormat';
import { Cart as CartShape, Discount, LineItem as CartLineItem } from 'types/entity/cart';

export interface SlideOutProps {
  cart?: CartShape;
  isEmpty?: boolean;
  onApplyDiscountCode?: (code: string) => Promise<void>;
  onRemoveDiscountCode?: (discount: Discount) => Promise<void>;
  totalCartItems?: number;
  onRemoveItem(itemId: string, customLineItemId?: string): Promise<void>;
  onUpdateItem(itemId: string, customLineItemId: string | undefined, quantity: number): Promise<void>;
  onClose?: () => void;
  emptyCartTitle: string;
  emptyCartSubtitle: string;
  emptyCartImage?: ImageProps;
  emptyCartCategories?: Link[];
  sideCartPaymentMethods: Array<PaymentMethod>;
}

const Slideout: React.FC<SlideOutProps> = ({
  cart,
  isEmpty,
  onApplyDiscountCode,
  onRemoveDiscountCode,
  onRemoveItem,
  onUpdateItem,
  onClose,
  sideCartPaymentMethods,
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartCategories,
}) => {
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });

  const title = formatCartMessage({ id: 'myCart', defaultMessage: 'Cart' });

  return (
    <>
      <div className="flex p-16 pb-0">
        <div className="flex w-full items-center justify-between border-b-2 border-stroke-primary px-16 py-12">
          <h3 className="body-text-large font-medium">{title}</h3>
          <div className="flex h-full items-center gap-24">
            <button onClick={onClose} className="cursor-pointer transition hover:opacity-80" data-testid="close-icon">
              <CloseIcon className="w-24" />
            </button>
          </div>
        </div>
      </div>
      <Cart
        cart={cart}
        isEmpty={isEmpty}
        onApplyDiscountCode={onApplyDiscountCode}
        onRemoveDiscountCode={onRemoveDiscountCode}
        emptyStateTitle={emptyCartTitle}
        emptyStateSubtitle={emptyCartSubtitle}
        emptyStateCategories={emptyCartCategories}
        handleCategoryClick={onClose}
        onRemoveItem={onRemoveItem}
        onUpdateItem={onUpdateItem}
        sideCartPaymentMethods={sideCartPaymentMethods}
      />
    </>
  );
};

export default Slideout;
